import * as React from "react";
import OdxAreaHeader from "../../../OdxComponents/NativeOdx/Odx-AreaHeader";
import OdxChip from "../../../OdxComponents/NativeOdx/Odx-Chip";
import {odxVariants} from "../../../OdxComponents/constants";
import {useMain} from "../../../Utils/SessionControls/mainContext";
import OdxBreadcrumbs from "../../../OdxComponents/NativeOdx/Odx-Breadcrumbs";
import OdxContentBox from "../../../OdxComponents/NativeOdx/Odx-Contentbox";

const DOOPDocumentation: React.FC = () => {

    const {setLoading} = useMain();

    setLoading(false)
    return (
        <div>
            <OdxBreadcrumbs/>

            <OdxAreaHeader
                text="DevOps Integrated Order Processing (DOOP)"
                odxSize="large"
                className={'!pl-0 !pr-0'}
            />
            <OdxContentBox>
                <div className="flex items-center mb-4">
                    <OdxChip
                        content="Dräger developed"
                        size="medium"
                        variant={odxVariants.secondary}
                    />
                </div>
                <p>
                    This document provides a comprehensive overview of the DevOps Integrated Order Processing (DOOP) in
                    the MS Azure DevOps. This module is designed to support the development, order, and invoice process
                    with external partners/developers. It enables the price and material cooperation models in MS Azure
                    DevOps projects and guides product teams through the ordering process using workflow components.
                </p>
                <odx-separator style={{margin: '1rem 0'}} />
                <h5>Features</h5>
                <ul>
                    <li>Order tracking: The user can track the order via different states of the user story (New,
                        Estimate and Quote, Quote Acceptance, Order, Ordered, Active, Request for Acceptance, Done,
                        Closed).
                    </li>
                    <li>Email Notification: Automated email notifications to relevant parties at different stages of the
                        process.
                    </li>
                    <li>Role-based access: Role-based validity checks for transitioning between different states.</li>
                </ul>
                <odx-separator style={{margin: '1rem 0'}} />
                <h5>Requirements</h5>
                <ul>
                    <li>MS Azure DevOps project (AGILE project type)</li>
                    <li>Pre-defined SAP-order with a fixed amount of money (optional)</li>
                    <li>Set-up of DOOP for project</li>
                </ul>
                <odx-separator style={{margin: '1rem 0'}} />
                <h5>Set-up Instructions</h5>
                <p>
                    When ordering a new project via the Service Portal, select AGILE as the work item space. The project
                    will get the process Agile (default) in the first step. In the second step, this can be extended to
                    the process Agile - all inclusive. For additional information to setup DOOP and configure the
                    settings for administrators, refer to the KB article DOOP for Admins.
                </p>
                <odx-separator style={{margin: '1rem 0'}} />
                <h5>Further Documentation</h5>
                <ul>
                    <li>DOOP for Admins ServiceNow Knowledgebase</li>
                    <li>
                        <a href="https://dev.azure.com/draeger/DevOps%20OrderProcess2%20(DOOP)/_wiki/wikis/DevOps-OrderProcess2-(DOOP).wiki/3973/DOOP2">
                            ADO Project & Wiki for Admins & Devs
                        </a>
                    </li>
                </ul>
            </OdxContentBox>
        </div>
    );
};

export default DOOPDocumentation;
